import { Parente, UserInvestor } from '../../../../user-signup/model/user-investor.model';
import { ProfileData } from '../../../../../../profile-data/model/profile-data';
import { IncomeEquityData } from '../../../../../../income-wealth/model/income-equity-data';
import { MaritalStatus } from '../../../../../../marital-status/model/marital-status-data';
import { PersonalData } from '../../../../../../personal-data/model/personal-data';
import { ProfessionalData } from '../../../../../../professional-data/model/professional-data';
import { Address } from '../../../../../../address/model/address';
import { Servicos } from '../../../../../../pages/rlp/model/servicos.model';

interface UserData {
  profileData: ProfileData;
  personalData: PersonalData;
  maritalStatus: MaritalStatus;
  address: Address;
  professionalData: ProfessionalData;
  incomeEquity: IncomeEquityData;
  idInvestor?: string;
  contaIon: boolean;
  servicos: Servicos
}

export class UserInvestorParseData {
  public static formatToUserSignup(data: UserData, initialData?: any): UserInvestor {
    return {
      id_investidor: data.idInvestor ? data.idInvestor : undefined,
      cpf_cnpj: data.personalData.cpf?.length === 11 ? `000${data.personalData.cpf?.replace(/\D+/g, '')}` : data.personalData.cpf?.replace(/\D+/g, ''),
      sexo: data.personalData.genderCode,
      nome_completo: data.personalData.documentName,
      nome: data.personalData.name,
      nome_fantasia_apelido: data.profileData.name,
      data_nascimento_fundacao: this.formatDate(data.personalData.dateOfBirth),
      codigo_cidade_nascimento_ibge: data.personalData.cityOfBirth,
      uf_nascimento_fundacao: data.personalData.uFOfBirth,
      cidade_nascimento: data.personalData.cityOfBirthName,
      regiao_nascimento_fundacao: !data.personalData.regionBirthFoundation && data.personalData.countryOfBirth !== 'BR' ? data?.personalData?.countryOfBirthName
      : data.personalData.regionBirthFoundation,
      pais_nascimento_fundacao: data.personalData.countryOfBirth,
      estado_civil: data.maritalStatus.maritalStatus === undefined ? 0 : parseInt(data.maritalStatus.maritalStatus, 10),
      patrimonio: data.incomeEquity.noPatrimony ? 0 : parseFloat(this.verifyFormatIncome(data.incomeEquity.patrimony)),
      renda_faturamento: data.incomeEquity.noIncome ? 0 : parseFloat(this.verifyFormatIncome(data.incomeEquity.income)),
      sem_patrimonio: data.incomeEquity.noPatrimony,
      sem_renda_faturamento: data.incomeEquity.noIncome,
      vinculo_corretora: data.incomeEquity.personLinkedToTheBrokerage,
      origem_renda: data.professionalData.originIncome  ===  undefined ? 0 : parseInt(data.professionalData.originIncome, 10),
      profissao: data.professionalData.profession ? parseInt(data.professionalData.profession, 10) : undefined,
      nome_pessoa_contratante: data.professionalData.entityThatWorks,
      cpf_cnpj_contratante: data.professionalData.entityCnpj?.replace(/\D+/g, ''),
      nacionalidades: data.personalData.nationality === undefined ? [0] : [parseInt(data.personalData.nationality, 10)],
      paises_residencia_fiscal: data.incomeEquity.taxResidence ? [ data.incomeEquity.taxResidence ] : undefined,
      documentos: [
        {
            tipo: data.personalData.documentType === undefined ? 0 : parseInt(data.personalData.documentType, 10),
            numero: `${data.personalData.documentNumber}`,
            orgao_expedidor: data.personalData.issuingAgency === undefined ? 0 : parseInt(data.personalData.issuingAgency, 10),
            uf: data.personalData.expeditionState,
        }
      ],
      enderecos: [
        {
            cep: data.address.postalCode,
            logradouro: data.address.street,
            numero: data.address.number,
            complemento: data.address.adjunct,
            bairro: data.address.district,
            cidade: data.address.city,
            uf: data.address.state,
            pais: 'BR',
        }
      ],
      telefones: [
        {
            ddd: data.profileData.phoneNumber === undefined ? 0 : parseInt(data.profileData.phoneNumber?.replace(/\D+/g, '').substring(0, 2), 10),
            numero: data.profileData.phoneNumber?.replace(/\D+/g, '').substring(2),
        }
      ],
      emails: [
        {
            email: data.profileData.email.toLowerCase(),
        }
      ],
      servicos: {
        ativacao_custodia_remunerada : data?.servicos?.ativacao_custodia_remunerada ?? false,
        ativacao_rlp : data?.servicos?.ativacao_rlp ?? false
      },
      parentes: this.setListParents(data),
      ...(this.checkIsUpdate(data.idInvestor) && data.contaIon ? {residencia_fiscal_atualizacoes: this.createDataNif(data, initialData)} : null),
        };
  }
  public static setListParents(data: UserData): Parente[] {
    const motherData = {
        grau_parentesco: 601,
        nome: data.personalData.motherName,
    };

    if (data.maritalStatus.maritalStatus === '608'
        || data.maritalStatus.maritalStatus === '612') {
        return [
            motherData,
            {
                grau_parentesco: 598,
                nome: data.maritalStatus.spouseName,
                cpf: data.maritalStatus.spouseCpf,
                parente_estrangeiro: data.maritalStatus.foreignSpouse,
            }
        ];
    } else {
        return [motherData];
    }
  }

  public static formatDate(date: string): string {
    if (date) {
      const year = date.split('/')[2];
      const month = date.split('/')[1];
      const day = date.split('/')[0];

      return `${year}-${month}-${day}`;
    } else {
      return date;
    }
  }

  public static verifyFormatIncome(value: string) {
    return value && value.includes(',')
    ? value.replace(',', '.')
    : value;
  }

  public static checkIsUpdate(id_investidor: string): boolean {
    return id_investidor  ? true : false;
  }

  public static createDataNif(data: UserData, initialData: any) {
    const dataNif = {
      taxResidence: data.incomeEquity.taxResidence,
      taxResidenceName: data.incomeEquity.taxResidenceName,
      dateTaxResidency: data.incomeEquity.dateTaxResidency,
      nif: data.incomeEquity.nif
    }

    if (initialData.incomeEquity.taxResidence === '' || this.checkObjectIsEqual(dataNif, initialData.incomeEquity)) {
      return [];
    }

    if ((initialData.incomeEquity.taxResidence === 'BR' || dataNif.taxResidence === initialData.incomeEquity.taxResidence) && !this.checkObjectIsEqual(dataNif, initialData.incomeEquity)
    ) {
      return [
        {
          pais_residencia_fiscal_sigla: data.incomeEquity.taxResidence,
          numero_identificacao_fiscal: data.incomeEquity.nif,
          data_residencia_fiscal: this.formatDate(data.incomeEquity.dateTaxResidency),
          exclusao_residencia_fiscal: false
        }
      ]
    }

    if ((initialData.incomeEquity.taxResidence !== '' && initialData.incomeEquity.taxResidence !== 'BR') && dataNif.taxResidence !== initialData.incomeEquity.taxResidence) {
      return [
        {
          pais_residencia_fiscal_sigla: initialData.incomeEquity.taxResidence,
          numero_identificacao_fiscal: initialData.incomeEquity.nif,
          data_residencia_fiscal: this.formatDate(initialData.incomeEquity.dateTaxResidency),
          exclusao_residencia_fiscal: true
        },
        {
          pais_residencia_fiscal_sigla: data.incomeEquity.taxResidence,
          numero_identificacao_fiscal: data.incomeEquity.nif,
          data_residencia_fiscal: this.formatDate(data.incomeEquity.dateTaxResidency),
          exclusao_residencia_fiscal: false
        }
      ]
    }

    return [];
  }

  public static checkObjectIsEqual(x: object, y: object) {
    return JSON.stringify(x) === JSON.stringify(y);
  }


}
